module.exports = __webpack_public_path__ + "static/media/flutter_bookstore.477da510.jpg";